import React from "react";
import { Image, VStack } from "@chakra-ui/react";

import { ChakraText } from "../../ChakraText";

import server_error from "assets/server_error.svg";
import { NotificationPrototype } from "./NotificationPrototype";

const ServerError = () => {
  return (
    <NotificationPrototype>
      <VStack spacing={6}>
        <Image
          maxH="400px"
          src={server_error}
          alt="Zdjęcie - nieznany problem"
        />
        <ChakraText fontSize="3xl">
          Wystąpił problem z serwerem, spróbuj ponownie później lub skontaktuj
          się z administratorem
        </ChakraText>
      </VStack>
    </NotificationPrototype>
  );
};

export { ServerError };
